export default "__VITE_ASSET__f862c2c9__"